import { store } from "@Redux/store";
import { removeUser } from "@Redux/userSlice";
import { setSnackbar } from "@Redux/snackBarSlice";

export const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  store.dispatch(removeUser());
  store.dispatch(
    setSnackbar({
      open: true,
      message: "Please login again.",
      error: true,
    })
  );
  window.location.href = "/";
};
